import React from 'react'
import { useTranslation } from 'react-i18next';
import DataPickerHLPure from '../datePickerHL/datePickerHL.pure';
import ButtonHLPure from '../buttonHL/buttonHL.pure';

function DashboardDateFilter(props) {
    const { dates, handleChangeDate, handleSearch } = props
    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'allClientsScreen' });

    return (
        <div className="dashboardView-card dashboardView-date-filter">
            <label className="dashboardView-card-label">{t("periodFilter")}</label>
            <div className="dashboardView-card-dates">
                <DataPickerHLPure
                    id="dateEndFilter"
                    valueDate={dates.startDate || ''}
                    handleChangeDate={(e) => handleChangeDate(e, 'startDate')}
                />
                <span>al</span>
                <DataPickerHLPure
                    id="dateEndFilter"
                    valueDate={dates.endDate || ''}
                    handleChangeDate={(e) => handleChangeDate(e, 'endDate')}
                />
            </div>
            <ButtonHLPure primary nameBtn={t("consult")} onClick={handleSearch} />
        </div>
    )
}

export default DashboardDateFilter